import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useAdminBadgeCount } from './useAdminBadgeCount';

/**
 * Number of upstream providers with an actionable issue right now (spend at
 * soft-alert, 24h reliability degraded, missing key on an active provider,
 * fresh low balance). Drives the red badge on the Dev Console Providers card.
 */
export function useProviderIssueCount(): number {
  return useAdminBadgeCount(queryKeys.adminProviders.issueCount(), () =>
    api.adminGetProviderIssueCount(),
  );
}
